import { createMuiTheme } from 'theme/muiTheme';

// MUI's default Tooltip background is always dark, regardless of the app's light/dark mode,
// so tooltip content needs the dark theme's palette to stay readable against it.
export const tooltipPalette = createMuiTheme('dark').palette;
